/* ==========================================================================
   RK PRODUKTEMPFEHLUNGEN — nachladen statt blockieren
   Powered by René Kress - Crovio · www.crovio.de
   ========================================================================== */
(function () {
  'use strict';

  function laden(box) {
    var url = box.getAttribute('data-url');
    if (!url) return;

    fetch(url)
      .then(function (a) { return a.text(); })
      .then(function (text) {
        var frisch = new DOMParser().parseFromString(text, 'text/html')
          .querySelector('[data-rk-empfehlungen]');
        if (frisch && frisch.innerHTML.trim()) {
          box.innerHTML = frisch.innerHTML;
          /* Die Kacheln kommen erst jetzt ins Dokument — ohne dieses Signal
             bliebe ihr Auftritt aus und sie stünden starr da. */
          document.dispatchEvent(new CustomEvent('rk:inhalt-neu'));
        } else {
          box.remove();   /* Keine Empfehlungen: keine leere Überschrift stehen lassen */
        }
      })
      .catch(function () { box.remove(); });
  }

  function los() {
    document.querySelectorAll('[data-rk-empfehlungen]').forEach(function (box) {
      /* Erst laden, wenn der Bereich in die Nähe des Bildschirms kommt */
      if (!('IntersectionObserver' in window)) { laden(box); return; }
      var beobachter = new IntersectionObserver(function (eintraege) {
        eintraege.forEach(function (e) {
          if (e.isIntersecting) { beobachter.disconnect(); laden(box); }
        });
      }, { rootMargin: '600px' });
      /* Sicherheitsnetz: Hat der Beobachter nach drei Sekunden nicht
         ausgelöst — etwa weil der Abschnitt zu klein ist —, laden wir
         trotzdem. Lieber einmal zu viel geladen als nie. */
      setTimeout(function () {
        if (box.isConnected && box.innerHTML.trim().length < 80) {
          beobachter.disconnect();
          laden(box);
        }
      }, 3000);
      beobachter.observe(box);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', los);
  } else { los(); }
  document.addEventListener('shopify:section:load', los);
})();
